<app-fetch-package-users></app-fetch-package-users>
<div class="content-container">
  @if ((signingAgent$ | async); as signingAgent) {
    <div class="participants">
      <app-welcome-participant [participant]="signingAgent"></app-welcome-participant>
    </div>
  }
  <p class="tip">
    <b>Status:</b> {{ countNonSasCheckingIn$ | async }} out of {{ totalNonSas$ | async }} signers
    have arrived and began checking in.
  </p>

  <div class="button-container">
    @if ((isSaCheckedIn$ | async) === false) {
      <app-button
        (buttonClick)="beginCheckIn()"
        [type]="'primary'"
      [ariaLabel]="
        (isSaSelected$ | async) ? null : 'button disabled until participant selection is made'
      "
        [isDisabled]="(isSaSelected$ | async) === false"
        [dataTestId]="'begin-check-in-button'"
        >Begin Check In</app-button
        >
      } @else {
        <app-button
          (buttonClick)="goToWaitingRoom()"
          [type]="'primary'"
    [ariaLabel]="
      (isSaSelected$ | async) ? null : 'button disabled until participant selection is made'
    "
          [isDisabled]="(isSaSelected$ | async) === false"
          [dataTestId]="'go-to-waiting-room-button'"
          >Go to Waiting Room</app-button
          >
        }
      </div>
    </div>

